import React, {FC, useContext} from "react"
import LayoutContext from "../../context/LayoutContext"
import PLPBikesList from "./PLPBikesList" // Updated import
import NoBikesState from "./NoBikesState"
import ComparisonPLPFixedComponent from "./ComparisonPLPFixedComponent"
import SpecialPromotionBanner from "./SpecialPromotionBanner"
import StaticTile, {getTileArrToShow} from "./StaticTile"

type Props = {
  filteredBikes: any[];
  filtersLoading: boolean;
  bikesList?: any[];
  isLoadingMoreProducts: boolean;
  isOccasionContent?: boolean;
  filteredProductsLength?: number;
};

const AllBikesCollection: FC<Props> = ({
	filteredBikes,
	filtersLoading,
	bikesList,
	isOccasionContent,
	isLoadingMoreProducts
}): React.ReactElement => {
	const {isMobile, isListView} = useContext(LayoutContext)
	const jumpsNumber = isMobile ? 4 : 7
	const tileArrayLength = getTileArrToShow(isMobile)?.length

	const bannerValues: any = null
	const BannerOptions: any = null

	return (
		<>
			{filteredBikes?.length ? (
				<>
					<div
						className={`position-relative col-12 ${
							isListView ?
								` ${isMobile ? "d-flex align-items-center flex-column gap-0 container  justify-content-center" : "row d-flex px-4"}  ${isOccasionContent ? "gy-4" : "gy-2"} mt-md-3` :
								`${filteredBikes.length < 3 ? "d-flex justify-content-center" : "bikes-collection"}`
						}`}
					>
						{bannerValues && bannerValues.displayOptions === BannerOptions.afterFilters && (
							<div className="d-block d-md-none">
								<SpecialPromotionBanner
									bannerImg={bannerValues.bannerImg}
									displayOptions={bannerValues.displayOptions}
								/>
							</div>
						)}

						<PLPBikesList
							filteredBikes={filteredBikes}
							isListView={isListView}
							isMobile={isMobile}
							isOccasionContent={isOccasionContent}
							jumpsNumber={jumpsNumber}
							tileArrayLength={tileArrayLength}
						/>
						<div className="d-none d-md-block">
							{filteredBikes.length < 4 && <StaticTile index={tileArrayLength} />}
						</div>
						{filtersLoading && (
							<div style={{opacity: 0.8}}
								className="bg-white position-absolute top-0 start-0 bottom-0 end-0" />
						)}
					</div>
					<div className="d-md-none">
						{filteredBikes.length < 4 && <StaticTile index={tileArrayLength} />}
					</div>
				</>
			) : isLoadingMoreProducts ?
				null : <NoBikesState count={tileArrayLength} />}

			<ComparisonPLPFixedComponent sticky={true} />
		</>
	)
}

export default AllBikesCollection
